module.exports = __webpack_public_path__ + "img/font-awesome.66cbc037.png";